import { render, staticRenderFns } from "./_betListHDPOU.vue?vue&type=template&id=5d317ba4&lang=pug&"
import script from "./_betListHDPOU.vue?vue&type=script&lang=js&"
export * from "./_betListHDPOU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports